<template>
    <div id="page-top" class="reports-style-period-1">
        <!-- 封面區域 -->
        <!-- <Cover v-if="report_data.cropperiod_meta" :cropperiod_data="report_data.cropperiod_meta"></Cover> -->

        <div class="print-background">

            <div id="report-section-introduction">
                <Introduction :cropperiodData="report_data.cropperiod_meta"></Introduction>
            </div>

            <!-- <div id="report-section-growth-summary">
                <SummaryGrowthPeriodDiary :chartID="'chart-growth-period-diary'" :data="report_data" :theme="'dark'"></SummaryGrowthPeriodDiary>
            </div> -->

            <div id="report-section-diary" v-if="report_data.diary">
                <GalleryDiary :data="report_data.diary"></GalleryDiary>
            </div>

            <div id="report-section-timelapses">
                <TimeLapse :data="report_data.timelapses"></TimeLapse>
            </div>

            <!-- <div id="report-section-overall">
                <Overall :data="report_data.summary"></Overall>
            </div> -->

            <!-- <div class="comment-area">
                <div class="report-section print-hide-object">
                    <b-row align-h="center" class="report-section">
                        <b-col md=8>
                            <div class="comment-title" id="report-section-comment">{{ $t('menu.comment') }}</div>
                            <ReportComment :page_type="'report'" :page_id="getReportID" :user="user" :timezone="timezone"></ReportComment>
                        </b-col>
                    </b-row>
                </div>
            </div> -->

            <!-- 放在最下方 -->
            <ButtonTopRight :dropdown="dropdownList"></ButtonTopRight>

        </div>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import ButtonTopRight from '@/views/components/Button_TopRight'
import ecTools from '@/echarts/echarts-tools'
import ReportComment from '@/views/project/report/components/ReportComment'

// import TestData     from '@/views/project/report/Period_1.0/TestData'
import Cover        from '@/views/project/report/Period_Wedding/Cover'
import Introduction from '@/views/project/report/Period_Wedding/Introduction'
import SummaryGrowthPeriodDiary from '@/views/project/report/Period_Wedding/Summary_GrowthPeriod_Diary'
import Overall      from '@/views/project/report/Period_Wedding/Overall'
import TimeLapse    from '@/views/project/report/Period_Wedding/Time_Lapse'
import GalleryDiary from '@/views/project/report/Period_Wedding/Gallery_Diary'
import DetailStage  from '@/views/project/report/Period_Wedding/Detail_Stage'

export default {
    props: {
        report_data: {
            type: Object,
            require: true,
        },
        user: {
            type: Object,
            default: undefined,
        },
        timezone: {
            type: String,
            default: undefined,
        },
    },
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
        ButtonTopRight,
        ReportComment,

        Cover,
        Introduction,
        SummaryGrowthPeriodDiary,
        Overall,
        TimeLapse,
        GalleryDiary,
        DetailStage,
    },
    data () {
        return {
            date_range: '',
            report_url: '',

            // test_data: TestData,
        }
    },
    mounted ()
    {
        if (this.timezone == undefined) this.timezone = this.$tools.date.getTimezoneNow();
    },
    computed:
    {
        ...mapState({
            'user_language': state => state.user.language,
        }),

        getToken ()
        {
            return localStorage.token
        },
        getReportID ()
        {
            if ( this.$route.query && this.$route.query.id )
                return this.$route.query.id
            else undefined
        },

        dropdownList ()
        {
            let _list = [
                { icon: 'fa fa-paw', name_code: 'go_top', name: 'Top', href: '#page-top', },
                // { icon: 'fa fa-quote-left', name: `${ this.$t('report.type.period') } ${ this.$t('report.ui.introduction') }`, href: '#report-section-introduction', },
            ]
            if (this.report_data)
            {
                // _list.push( { icon: 'fa fa-calendar', name: `${ this.$t('report.ui.growth_summary') }`, href: '#report-section-growth-summary', }, )

                if (this.report_data.diary && this.report_data.diary.length > 0)
                {
                    _list.push( { icon: 'fa fa-book', name: `${ this.$t('menu.agridiary') }`, href: '#report-section-diary', }, )
                }

                // if (this.report_data.timelapses && this.report_data.timelapses.length > 0)
                // {
                    _list.push( { icon: 'fa fa-video-camera', name: `${ this.$t('report.ui.time_lapse_camera') }`, href: '#report-section-timelapses', }, )
                // }

                // _list.push( { icon: 'fa fa-pie-chart', name: `${ this.$t('report.ui.overall') }`, href: '#report-section-overall', }, )


                // _list.push( { icon: 'fa fa-pencil', name_code: 'comment', name: 'Comment', href: '#report-section-comment' } )
            }
            // console.log( _list )

            return _list
        },

        getLogDetail ()
        {
            return {
                page: 'report period',
                action: 'download pdf',
                querySettings: {
                    'project ID':       this.report_data.cropperiod_meta.project_id,
                    'cropperiod ID':    this.report_data.cropperiod_meta.id,
                    'cropperiod name':  this.report_data.cropperiod_meta.name,
                    'report name':      this.$t('menu.crop_records'),
                    'report type':      'period',
                    'report range':     this.date_range,
                    'report ID':        this.$route.query.id,
                    'report url':       this.report_url,
                },
                pageInfo: {
                    'project timezone':     this.report_data.cropperiod_meta.project_timezone,
                    'project status':       this.report_data.cropperiod_meta.project_status,
                },
            }
        },

    },
    methods: {


    }
}
</script>

<style lang="scss" scoped>

.comment-area
{
    background-color: rgb(37, 46, 39);

    .comment-title
    {
        text-align: center;
        font-size: 1.2rem;
        padding: 10px;
        color: #598068;
        border-bottom: #40604c 1px solid;
        margin-bottom: 15px;
    }
}



.overview-block
{
    vertical-align: top;
    margin: 5px 20px 5px 10px;
    font-size: 1.2rem;
}
.overview-block-title
{
    display: inline-block;
    // vertical-align: middle;
    margin-bottom: -2px;
    margin-right: 10px;
}
.overview-block-body
{
    display: inline-block;
    // vertical-align: middle;
    font-size: 1.8rem;
    color: #008060;
    border-bottom: 1px solid #c3e7e5;
}
.overview-block-unit
{
    display: inline-block;
    // vertical-align: bottom;
    margin-left: 10px;
}
.overview-stress
{
    display: inline-block;
    margin-right: 10px;
    // background-color: #ccdbe2;
    border-radius: 15px;
    border: 1px solid #eed688;

}
.overview-stress-count
{
    display: inline-block;
    margin: 0px 10px 0px 5px;
    font-size: 0.9rem;

    // vertical-align: top;
    // font-size: 0.8rem;
    // padding: 1px 3px;
    // margin-right: 5px;
    // margin-top: -5px;
    // color: #ffffff;
    // background-color: #1595cc; //#6fbd95;
    // border-radius: 3px;
}


.overview-device-title
{
    display: inline-block;
    font-size: 1.5rem;
    color: #385f53;
    border-bottom: 1px solid #b8da8c;
    padding: 1px 15px 1px 8px;
    margin-bottom: 10px;
}
.overview-device-block
{
    display: inline-block;
    padding: 5px;
    margin-bottom: 10px;


    .device-info
    {
        display: inline-block;
        margin-right: 10px;
    }
    .device-hashid
    {
        font-size: 0.8rem;
        margin-left: 8px;
    }
    .device-deviceid {
        font-size: 0.75rem;
        margin-left: 5px;
    }

    .device-name
    {
        display: inline-block;
        font-size: 1.2rem;
        margin-right: 5px;
        i {
            color: #cea212;
        }
    }
    .device-up-info
    {
        //display: inline-block;
        margin-left: 30px;
        margin-bottom: -3px;
        margin-right: 20px;
        color: #747974;
    }
    .device-down-info
    {
        //display: inline-block;
        margin-left: 25px;
        margin-top: -10px;
        margin-right: 20px;
        color: #747974;
    }
}

</style>

